import React from "react";
import { Link, useLocation } from "react-router-dom";

const HomeIcon = ({ filled }) =>
  filled ? (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.47 3.84a.75.75 0 011.06 0l8.69 8.69a.75.75 0 101.06-1.06l-8.689-8.69a2.25 2.25 0 00-3.182 0l-8.69 8.69a.75.75 0 001.061 1.06l8.69-8.689z" />
      <path d="M12 5.432l8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 01-.75-.75v-4.5a.75.75 0 00-.75-.75h-3a.75.75 0 00-.75.75V21a.75.75 0 01-.75.75H5.625a1.875 1.875 0 01-1.875-1.875v-6.198c.03-.028.061-.056.091-.086L12 5.432z" />
    </svg>
  ) : (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12l8.954-8.955a1.126 1.126 0 011.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
    </svg>
  );

const ProfileIcon = ({ filled }) =>
  filled ? (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z" clipRule="evenodd" />
    </svg>
  ) : (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
    </svg>
  );

const FooterButton = ({ to, icon, label }) => {
  const { pathname } = useLocation();

  const isActive =
    (icon === "home" && pathname === "/home") ||
    (icon === "profile" && pathname === "/profile");

  const activeColor = "#FFB703";
  const inactiveColor = "#9CA3AF";
  const color = isActive ? activeColor : inactiveColor;

  return (
    <Link to={to} className="flex-1 flex justify-center">
      <div className="flex flex-col items-center gap-1 py-2 w-full max-w-[120px]">
        {/* Icon container */}
        <div
          className="w-11 h-11 flex items-center justify-center rounded-2xl transition-colors duration-200"
          style={{ backgroundColor: isActive ? "#FFF3CD" : "transparent" }}
        >
          <span style={{ color }}>
            {icon === "home" && <HomeIcon filled={isActive} />}
            {icon === "profile" && <ProfileIcon filled={isActive} />}
          </span>
        </div>

        {/* Label */}
        <span
          className="text-xs font-semibold transition-colors duration-200"
          style={{ color }}
        >
          {label}
        </span>
      </div>
    </Link>
  );
};

export default FooterButton;
